import { PRIVATE_MODULES_PATH } from "./root.path";

const BASE = PRIVATE_MODULES_PATH.LOGOUT;

export const PATH_ROUTER_PROFILE = {
  ROOT: BASE
};

export const PATH_ROUTES_PROFILE = {
  ROOT: `/${BASE}/`
};

const LOGOUT_PATH = {
  ROUTES: PATH_ROUTES_PROFILE,
  ROUTER: PATH_ROUTER_PROFILE
};
export default LOGOUT_PATH;
